import React from 'react';
import _ from 'lodash';

const DropDown = (props) => {
    const { widget, options, field, setWidgetFieldValue } = props;

    const selectOptions = options.map((option, index) => {
        const invalidDataType = option.availability &&
            !_.includes(option.availability, widget.dataType);

        return !invalidDataType && <option value={index} key={index}>{option.title}</option>;
    });

    // Can be both these cases and have to choose the index for which type is defined.
    const currentCustomOption = _.find(options, ['target', _.get(widget, 'dataConfig.endpoint')]);
    const currentOption = _.find(options, ['value', _.get(widget, field)]);

    return (
        <select
            value={_.indexOf(options, currentCustomOption || currentOption)}
            onChange={(event) => {
                const selectOption = options[event.target.value];
                const endpointValue = selectOption.value;

                if (endpointValue !== 'custom') {
                    setWidgetFieldValue(field, endpointValue);
                    setWidgetFieldValue('dataConfig.endpoint', '');
                } else {
                    setWidgetFieldValue(field, endpointValue);
                    setWidgetFieldValue('dataConfig.endpoint', selectOption.target);
                }
            }}
        >
            {selectOptions}
        </select>
    );
};

DropDown.propTypes = {
    widget: React.PropTypes.object,
    options: React.PropTypes.array,
    field: React.PropTypes.string,
    setWidgetFieldValue: React.PropTypes.func,
};

export default DropDown;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DropDown.jsx
 **/